import { render } from "./svgimage.vue?vue&type=template&id=68530337"
import script from "./svgimage.vue?vue&type=script&lang=js"
export * from "./svgimage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__